<template>
  <div id="smooth-wrapper">
    <div id="smooth-content">
      <UPage>
        <UPageBody class="pb-0">
      <ContentRenderer v-if="page" :value="page" :components="components" />
      
      </UPageBody>
      
      </UPage>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { loadGsap } from '@/utils/gsap'
import IntroSlide from '~/components/content/IntroSlide.vue'
import IntroButton from '~/components/content/IntroButton.vue'
import { useIntroStore } from '@/store/intro'
const introStore = useIntroStore()

const components = { IntroSlide }

const smoother = ref<any>(null)

const route = useRoute()

const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('pages').path(route.path).first()
})

onMounted(async () => {
  introStore.resetSlides();
 
})

onUnmounted(() => {
  
})
useContentSeo(page)
</script>
